import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { numberFromCurrency } from '@cred/shared/utils'
import {Dropdown, selectCustomWithAnalytics, MoneyInput} from '../components'
import styles from './styles.module.scss'

class MoneyFrequency extends Component {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    validate: PropTypes.func,
    autoComplete: PropTypes.bool,
    autoFocus: PropTypes.bool,
    focusAfter: PropTypes.number,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    analyticsContexts: PropTypes.array,
    nameStyle: PropTypes.oneOf(['snake', 'camel'])
  }

  static defaultProps = {
    className: null,
    validate: null,
    autoComplete: null,
    autoFocus: null,
    focusAfter: null,
    label: null,
    placeholder: null,
    analyticsContexts: [],
    nameStyle: 'snake'
  }

  constructor(props) {
    super(props)

    this.frequency = [
      {value: 'annually', label: 'Annually'},
      {value: 'monthly', label: 'Monthly'}
    ]
  }

  render() {
    const {
        className,
        name,
        validate,
        autoComplete,
        autoFocus,
        focusAfter,
        label,
        placeholder,
        analyticsContexts,
        nameStyle
      } = this.props,
      suffix = nameStyle === 'camel' ? 'Frequency' : '_frequency'

    return (
      <div className={[styles.wrapper, className].join(' ')}>
        <MoneyInput
          autoFocus={autoFocus}
          focusAfter={focusAfter}
          label={label}
          placeholder={placeholder}
          className={[styles.input, 'mr-md-8'].join(' ')}
          autoComplete={autoComplete}
          type="tel"
          name={`${name}`}
          validate={validate}
          analyticsContexts={analyticsContexts}
          parse={numberFromCurrency}
        />
        <Dropdown
          className={[styles.dropdown, 'mt-8', 'mt-md-0'].join(' ')}
          type="text"
          name={`${name}${suffix}`}
          options={this.frequency}
          component={selectCustomWithAnalytics}
          validate={validate}
          label="Frequency"
          placeholder="Frequency"
          analyticsContexts={analyticsContexts}
        />
      </div>
    )
  }
}

export {MoneyFrequency}
